import { globalData } from "./global.model";

export const GlobalDataFactory = () => {
    const gd = new globalData();
    return gd;
}

export const GlobalDataProvider = {
    provide: globalData,
    useFactory: GlobalDataFactory,
    deps: []
}